import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import APIUrls from "../../services/APIUrls";
import { updateCampaignId } from "../../redux/reducers/CampaignRightModalIdSlice";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import { dateFormat, dateDifferenceFromToday } from "../../services/Util";
import ProjectLanguageDetail from "../project/ProjectLanguageDetail";
import { RotatingLines } from "react-loader-spinner";
import CustomProgressBar from "../global/CustomProgressBar";
import Constants from "../../Constants";
import $ from "jquery";

export default function CampaignRightModal() {
  const dispatch = useDispatch();
  const [projectList, updateProjectList] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [activeClassId, setActiveClassId] = useState("");
  const [languageAssociated, setLanguages] = useState([]);
  const [langDetailLoaded, setLoadedState] = useState(true);
  const [languageProgress, setLanguageProgress] = useState("");
  const [activeTab, setActiveSection] = useState("Projects");
  const [loader,setLoader]=useState(false)
  const ReduxCampaignId = useSelector((state) => state?.campaign_id?.value);
  const filterAssignee = () => {
    var element = document.getElementById("assignee-box");
    element.classList.toggle("open");
  };

  useEffect(() => {
    setLoader(true);
    if (ReduxCampaignId) {
      Promise.all([
        getAxiosResponse(APIUrls.CAMPAIGN_DETAIL(ReduxCampaignId)),
        getAxiosResponse(APIUrls.CAMPAIGN_LANGUAGE_PROGRESS(ReduxCampaignId)),
        getAxiosResponse(APIUrls.PROJECT_LIST + `?workspaceId=${ReduxCampaignId}&onlyFollowed=false&page=1&pageSize=10`)
      ])
        .then(([campaignDetailRes, languageProgressRes, projectListRes]) => {
          const campaignDetailData = campaignDetailRes.data.data;
          const languageProgressData = languageProgressRes.data.data;
          const projectListData = projectListRes.data.data.result;

          setCampaignData(campaignDetailData);
          setLanguageProgress(languageProgressData);
          updateProjectList(projectListData);

          setLoader(false);
        })
        .catch(error => {
          console.error("Error fetching data:", error);
          setLoader(false);
        });
    } else {
      // Handle the case where ReduxCampaignId is undefined
      console.warn("ReduxCampaignId is undefined. Cannot fetch data.");
      setLoader(false);
    }
  }, [ReduxCampaignId]);

  function openTab(evt, rightTab) {
    if (rightTab === 'tab1') {
      setActiveSection('Languages');
      setTimeout(() => {
        $('.progressReport').removeAttr('tabindex');
      }, 300);
    } else if (rightTab === 'tab2') {
      setActiveSection('Projects');
    }
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("project-tab-content");
    var element = document.getElementById(rightTab);
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
      element.classList.remove("hide");
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(rightTab).style.display = "block";
    evt.currentTarget.className += " active";
  }
  function hideRightModel() {
        const isStatusClicked = $('.focusStatus').length;
        dispatch(updateCampaignId(""));
        document.body.classList.remove("modal-open");
        if (isStatusClicked) {
          $('.focusStatus').trigger('focus');
          $('.focusStatus').removeClass('focusStatus');
        } else {
        $('#row-'+ReduxCampaignId+' a').trigger('focus')
        }
  }
  const openAdvanceFilter = (id) => {
    setLoadedState(true);

    activeClassId === id ? setActiveClassId("") : setActiveClassId(id);
    getAxiosResponse(APIUrls.PROJECT_DELIVERABLE_STATUS(id))
      .then((res) => {
        if (res.data !== "") {
          setLanguages(res.data.data);
          setLoadedState(false);
          setTimeout(() => {
            $('.progressReport').removeAttr('tabindex');
          }, 300);
        }
      })

      if (  $('#project-dropdown-button-'+id).attr('aria-expanded')=== 'true'){
        $('#project-dropdown-button-'+id).attr('aria-expanded','false');
      }
      else{
        $('#project-dropdown-button-'+id).attr('aria-expanded','true');
      }
    
  };
  useEffect(()=>{
      if (campaignData?.workspace !== undefined) {
        $("#close-right-popup").trigger("focus");
      }
  }, [campaignData])

  const escapeModal = (event) => {
    const elem = $('.campaign-right-modal #openFilter:last');
    const elemList = $('.uploaded-doc-list li.flex-center:last button:last');
    const isDataNotAvaliable = $(event.target).next().find('.langDetails').length > 0;
    const isOnCloseBtn = $(event.target).is($('#close-right-popup'));
    const isOpenFIlterExists = $('#openFilter').length;
    const closestOpenFilter = $(event.target).closest('#openFilter');
    const isuploadedDocListExists = $('.campaign-right-modal #openFilter:last .language-block:last + div .uploaded-doc-list').length;
    const isDataLoading = $(event.target).next().find('.dataLoading').length > 0;
    const isNextElementHidden = $(event.target).next().hasClass('hide');
    if(event.key === Constants.TAB && !event.shiftKey) {
      if (activeTab==="Projects") {
        if((!isOpenFIlterExists && $('#projectsTabModal').is(':focus')) ||
        ($(document.activeElement).attr('aria-expanded')==='true' && $('.loadingLanguageDetails').length)){
          event.preventDefault();
          $('#close-right-popup').trigger('focus');
        } else if(closestOpenFilter.is(':last-child') &&
        $(event.target).is("[id*='project-dropdown-button']") &&
        ($(event.target).attr('aria-expanded')==='false' || closestOpenFilter.find('.no-data-display').length)
        ){
          event.preventDefault();
          $('#close-right-popup').trigger('focus');
        } else if($('.language-block').last().is($(document.activeElement)) &&
        $(document.activeElement).attr('aria-expanded')==='false' ||
        $(event.target).is(elemList) && elem.has($(event.target)).length > 0){
            event.preventDefault();
            $('#close-right-popup').trigger('focus');
        } else if((isDataNotAvaliable &&
          !$(event.target).parent().find('.uploaded-doc-list').length &&
          $(event.target).is(elem.find('.language-block'))) ||
          isDataLoading && !isNextElementHidden && $(event.target).is(elem.find('.language-block'))
          ){
          event.preventDefault();
          $('#close-right-popup').trigger('focus');
        }
      } else if (activeTab==="Languages") {
        if($('#projectsTabModal').is(':focus')){
          event.preventDefault();
          $('#close-right-popup').trigger('focus');
        }
      }
    } else if (event.key === Constants.TAB && event.shiftKey) {
      if (activeTab==="Projects") {
        if(!isOpenFIlterExists && $('#close-right-popup').is(':focus')){
          event.preventDefault();
          $('#projectsTabModal').trigger('focus');
        } else if(isOpenFIlterExists && isOnCloseBtn
        && $('#openFilter:last-child').find("[id*='project-dropdown-button']").attr('aria-expanded')==='false'
        ){
          event.preventDefault();
          $('#openFilter:last-child button.pos-arrow').trigger('focus');
        } else if (isOnCloseBtn && isuploadedDocListExists && elem.find('.language-block:last').attr('aria-expanded')==='true') {
          event.preventDefault();
          elemList.trigger('focus');
        } else if(
        (elem.find('.langDetails').length > 0 && !isuploadedDocListExists && isOnCloseBtn) ||
        elem.find('.dataLoading').length > 0 && isOnCloseBtn
        ){
          event.preventDefault();
          $('#openFilter:last-child .language-block:last').trigger('focus');
        } else if(isOpenFIlterExists && isOnCloseBtn){
          event.preventDefault();
          $('#tab2 #openFilter:last-child button').trigger('focus');
        }
      } else if (activeTab==="Languages") {
        if($('#close-right-popup').is(':focus')){
          event.preventDefault();
          $('#projectsTabModal').trigger('focus');
        }
      }
    } else if (event.key === Constants.ESCAPE) {
      hideRightModel();
    }
  }
  return (
    <div className="right-modal campaign-right-modal" aria-labelledby="skt_date" aria-modal="true" role="dialog"
    onKeyDown={(e)=>escapeModal(e)}
    >
      <div className="modal-header flex">
        <div className="left flex-center">
          <strong id="skt_date">
            {campaignData?.workspace?.name}
            {campaignData?.workspace !== undefined ?  <>- {" "}{dateFormat(campaignData?.workspace?.createdDate, Constants.DATE_FORMAT_YEAR)}</> : "" }
          </strong>
        </div>
        <button
          className="close flex-center"
          aria-label="close"
          id='close-right-popup'
          onClick={hideRightModel}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
          >
            <path
              d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
              fill="white"
            />
            <path
              d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
      <div className="modal-content">
        <ul className="tab-link flex-center tabs" role="tablist">
          <li role="none" className="tablinks" onClick={(event) => openTab(event, "tab1")}    
          >
            <Link to=""
              role="tab"
              aria-label={activeTab === "Languages" ? "Current tab, Languages" : "Languages"}
              aria-selected={activeTab === "Languages" ? "true" : "false"}
            >Languages</Link>
          </li>
          <li
            className="tablinks active"
            onClick={(event) => openTab(event, "tab2")}
            role="none"
          >
            <Link to=""
              role="tab"
              id="projectsTabModal"
              aria-label={activeTab === "Projects" ? "Current tab, Projects" : "Projects"}
              aria-selected={activeTab === "Projects" ? "true" : "false"}
            >Projects</Link>
          </li>
        </ul>
        <div className="right-tab-content">
          <div id="tab1" className="project-tab-content hide">
            <table>
              <tbody>
                {!loader && languageProgress && languageProgress !== "" && languageProgress !==null ? (
                  Object.keys(languageProgress)?.map((item, i) => (
                    <tr className="" key={i}>
                      <td className=""> {item}</td>
                      <td className="">
                        <CustomProgressBar
                          completed={languageProgress[item]}
                          labelSize="18px"
                          width="100%"
                          labelClassName="progressBarLabel"
                          borderRadius="0 2px 2px 0"
                          labelAlignment="right"
                          labelColor="rgba(0,0,0,0.87)"
                          customLabel={languageProgress[item] + " %"}
                          height="18px"
                          className=""
                          bgColor="rgb(106, 27, 154)"
                          baseBgColor="transparent"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>
                      <div className="no-data-display align-center">
                        <i className="nodata-icon"></i>
                        <p>{Constants.NO_DATA_FOUND}</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div id="tab2" className="project-tab-content">
            {projectList.length !== 0 ? (
              projectList.map((project) => {
                return (
                  <div
                    id="openFilter"
                    className={
                      activeClassId === project.id
                        ? "project-tab-list active"
                        : "project-tab-list"
                    }
                    key={project.id}
                  >
                    <div className="flex project-top-content">
                      <div className="icon-block light-green">
                        <i className="folder-icon"></i>
                      </div>
                      <div className="right-content">
                        <h5 role="none"><Link to={`/project/${project.id}`}>{project.name}</Link></h5>
                        <p>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="11"
                            viewBox="0 0 14 11"
                            fill="none"
                          >
                            <path
                              d="M12.6875 1.83333H7.4375L5.6875 0H1.3125C0.587617 0 0 0.615599 0 1.375V9.625C0 10.3844 0.587617 11 1.3125 11H12.6875C13.4124 11 14 10.3844 14 9.625V3.20833C14 2.44893 13.4124 1.83333 12.6875 1.83333Z"
                              fill="#D2D2D2"
                            />
                          </svg>
                          <strong>Content Source </strong> --{" "}
                          {project.projectContentTypeDisplay}
                        </p>
                      </div>
                      <button
                      id={"project-dropdown-button-"+project.id}
                        className="pos-arrow dd"
                        onClick={() => openAdvanceFilter(project.id)}
                        aria-expanded={false}
                        aria-label= {`${(project.name)}` + " details"}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="8"
                          viewBox="0 0 15 8"
                          fill="none"
                        >
                          <path
                            d="M14 7L7.5 1L1 7"
                            stroke="#ABB5BE"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                    <ul className="flex project-bottom-content">
                      <li>
                        <strong>{project.userGroup.name}</strong>
                        <span>Department</span>
                      </li>
                      <li>
                        <strong>{project.status.display}</strong>
                        <span>Project Status</span>
                      </li>
                      <li>
                        <strong className="green-text">
                          {dateDifferenceFromToday(project.dueDate?.utcTimestamp, "days")}
                        </strong>
                        <span>Due date</span>
                      </li>
                    </ul>
                    <div className="advance-filter">
                      {langDetailLoaded ? (
                        <div className="loadingLanguageDetails" style={{ textAlign: "center" }}>
                          <RotatingLines
                            strokeColor="grey"
                            strokeWidth="5"
                            width="96"
                            visible={langDetailLoaded}
                          />
                        </div>
                      ) : languageAssociated.length === 0 ? (
                        <div className="no-data-display align-center">
                          <i className="nodata-icon"></i>
                          <p>{Constants.NO_DATA_FOUND}</p>
                        </div>
                      ) : (
                        languageAssociated.map((language, key) => {
                          return (
                            <div key={key}>
                              <ProjectLanguageDetail
                                language_detail={language}
                                project_id={project.id}
                              />
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-data-display align-center">
                <i className="nodata-icon"></i>
                <p>{Constants.NO_DATA_FOUND}</p>
              </div>
            )}
          </div>
        </div>
      </div>
        <div className={loader ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={loader}
          />
        </div>
      </div>
    </div>
  );
}
